import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionCruiseControl"
const OptionCruiseControlIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m6.901 7.902-4.901-1.313 6.214-3.589zm4.052 10.666c-.106-.184-.182-.404-.261-.704-.078-.299-.158-.68-.239-1.13-.065-.357-.127-.738-.184-1.119-.035-.228-.06-.406-.075-.51l-.331-2.425 1.934 1.499c.079.061.214.167.386.305.287.229.575.463.844.69.089.076.089.076.178.151.646.554 1.028.924 1.212 1.243.553.957.225 2.18-.732 2.732-.956.552-2.18.225-2.732-.732zm8.218.501c.321-.804.498-1.681.498-2.599 0-.919-.177-1.796-.498-2.599l-1.239.715c-.478.276-1.09.112-1.365-.366-.277-.479-.113-1.09.365-1.366l1.237-.714c-1.087-1.379-2.681-2.339-4.5-2.599v1.429c0 .552-.447 1-1 1-.552 0-1-.448-1-1v-1.429c-1.82.26-3.414 1.22-4.5 2.599l1.237.714c.478.276.642.887.366 1.366-.276.478-.888.642-1.366.366l-1.238-.715c-.322.803-.499 1.68-.499 2.599 0 .918.177 1.795.499 2.599l1.238-.715c.478-.276 1.09-.113 1.366.366.276.478.112 1.09-.366 1.366l-1.484.857-1.5.865c-1.102-1.493-1.753-3.34-1.753-5.338 0-4.971 4.029-9 9-9s9 4.029 9 9c0 1.998-.651 3.845-1.754 5.338l-1.498-.865-1.485-.857c-.478-.276-.642-.888-.365-1.366.275-.479.887-.642 1.365-.366z" />
    </svg>
  )
}
export default OptionCruiseControlIcon
